module.exports = __webpack_public_path__ + "static/media/project-3.8599504d.png";